import React, { useState } from "react";
import config from "../../config";

const baseUrl = config.api.baseUrl;

export default function AgentTestModal({ agent, onClose }) {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const run = async () => {
    setRunning(true); setError(null); setResult(null);
    try {
      const r = await fetch(
        `${baseUrl}${config.api.endpoints.claudeAgent.adminAgents}/${agent._id}/test`,
        { method: "POST", credentials: "include" }
      );
      const j = await r.json();
      if (!r.ok || !j.success) throw new Error(j.error || `HTTP ${r.status}`);
      setResult(j.data);
    } catch (e) {
      setError(e.message);
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="ca-modal-backdrop">
      <div className="ca-modal">
        <h3>Smoke test: {agent.name}</h3>
        <p>Creates a one-shot Anthropic session, sends "say ok" to it, then deletes it.</p>
        {error && <div className="ca-admin-error">{error}</div>}
        {result && <div className="ca-admin-success">Session id: {result.session_id}</div>}
        <div className="ca-form-actions">
          <button onClick={onClose}>Close</button>
          <button onClick={run} disabled={running}>{running ? "Running…" : "Run"}</button>
        </div>
      </div>
    </div>
  );
}
